
import ConfigFile from "../../../../datasets/config_file";
import determineIfPartialCoupon from "./determine_if_partial_coupon";

export const calculateCouponValue = (bondInfo, gameDate, buyDate, tranType, investShortName,
        classification) => {
      
    let faceValue = ConfigFile.investments.bondFaceValue;
    if (bondInfo.faceValue){
        faceValue = bondInfo.faceValue;
    }
    const nbrPaymentsPerYear = (12 / +bondInfo.couponFrequency).toFixed(0);
   
    let couponValue = 0;
    if (classification === "Mortgage"){
        //  amortize the couponRate
        const monthlyRate = +bondInfo.couponRate / nbrPaymentsPerYear;
        let loanTerm = +bondInfo.term;
        if (bondInfo.termUnit === "Years"){
            loanTerm = +bondInfo.term * 12;
        } 
        couponValue = (faceValue * monthlyRate) / (1 - Math.pow(1 + monthlyRate, -loanTerm)).toFixed(2);
    }else{
        const couponRate = +bondInfo.couponRate / nbrPaymentsPerYear;
        couponValue = (+couponRate * faceValue).toFixed(3);
    }
    let partialMultiplier = 1;
    if (bondInfo.couponFrequency && +bondInfo.couponFrequency !== 1){
         partialMultiplier = determineIfPartialCoupon(bondInfo.couponFrequency, gameDate, buyDate, tranType);
    }
    couponValue = (couponValue * partialMultiplier).toFixed(2);
  
    let payoutObj = {investShortName: investShortName, tranType: "coupon",  
        sellPrice: couponValue, dateClosed: gameDate};
    
    return payoutObj;
}

export default calculateCouponValue;